import { WHY_US } from "@/data/content";
import { StarDash } from "@/components/StarDash";

const WhyUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="py-20 sm:py-32 bg-[#f5ede1] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="text-center reveal">
          <StarDash />
          <div className="mt-6 font-sans-body text-[11px] font-bold uppercase tracking-[0.32em] text-[#6b5a4a]">
            ★ Why pick INC.
          </div>
          <h2 className="font-display mt-4 text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-[#2b1a14] leading-[0.95]">
            Our cleaners
            <span className="font-italic-serif text-[#c63027]"> are different.</span>
          </h2>
          <p className="font-italic-serif mt-5 max-w-2xl mx-auto text-base sm:text-xl text-[#5a4636] leading-relaxed">
            Cleaning is craft. We hire carefully, train continuously, and build
            long relationships with our clients. The same cleaner. The same
            standard. Every single visit.
          </p>
        </div>

        <div
          className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          data-testid="why-grid"
        >
          {WHY_US.map((w, i) => (
            <div
              key={w.num}
              className="relative bg-[#fbf3e6] p-6 sm:p-8 reveal border border-[#d9c9b2]"
              style={{ transitionDelay: `${i * 60}ms` }}
              data-testid={`why-card-${w.num}`}
            >
              <div className="absolute -top-3 left-6 bg-[#c63027] text-[#fbf3e6] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.28em] font-sans-body">
                ★ {w.num}
              </div>
              <h3 className="font-display font-bold text-2xl text-[#2b1a14] mt-3 tracking-tight">
                {w.title}
              </h3>
              <p className="mt-3 text-base text-[#5a4636] leading-relaxed">
                {w.body}
              </p>
            </div>
          ))}
        </div>

        {/* Stats strip */}
        <div className="mt-16 grid grid-cols-3 max-w-3xl mx-auto bg-[#c63027] text-[#fbf3e6]">
          {[
            { n: "21+", l: "Years Trusted" },
            { n: "1000s", l: "Homes Cleaned" },
            { n: "100%", l: "Satisfaction" },
          ].map((stat, i) => (
            <div
              key={stat.l}
              className={`px-3 sm:px-6 py-5 sm:py-7 text-center ${
                i < 2 ? "border-r border-[#fbf3e6]/20" : ""
              }`}
              data-testid={`stat-${stat.l.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="font-display font-bold text-3xl sm:text-5xl">
                {stat.n}
              </div>
              <div className="mt-2 font-sans-body text-[9px] sm:text-[10px] uppercase tracking-[0.18em] sm:tracking-[0.28em] opacity-90">
                ★ {stat.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
